<template>
  <z-dialog
    :model-value="modelValue"
    title="添加标签"
    width="420px"
    append-to-body
    align-center
    destroy-on-close
    @update:model-value="emit('update:modelValue', $event)"
  >
    <div class="message-label-dialog">
      <z-input
        v-model="draft"
        placeholder="输入标签后回车添加"
        maxlength="16"
        clearable
        @keydown.enter.prevent="addDraft"
      />
      <div v-if="labels.length" class="message-label-dialog__chips">
        <z-tag
          v-for="label in labels"
          :key="label"
          closable
          @close="remove(label)"
        >
          {{ label }}
        </z-tag>
      </div>
      <p v-else class="message-label-dialog__hint">尚未添加标签</p>
    </div>
    <template #footer>
      <z-button @click="emit('update:modelValue', false)">取消</z-button>
      <z-button type="primary" @click="confirm">确定</z-button>
    </template>
  </z-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import ZButton from '@zoryn/components/button'
import ZDialog from '@zoryn/components/dialog'
import ZInput from '@zoryn/components/input'
import ZTag from '@zoryn/components/tag'
import '@zoryn/components/button/style'
import '@zoryn/components/dialog/style'
import '@zoryn/components/input/style'
import '@zoryn/components/tag/style'

const props = defineProps<{
  modelValue: boolean
  labels?: string[]
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: [labels: string[]]
}>()

const draft = ref('')
const labels = ref<string[]>([])

watch(
  () => [props.modelValue, props.labels] as const,
  ([visible, next]) => {
    if (!visible) return
    draft.value = ''
    labels.value = [...(next ?? [])]
  }
)

function addDraft() {
  const value = draft.value.trim()
  if (!value) return
  if (!labels.value.includes(value) && labels.value.length < 10) {
    labels.value = [...labels.value, value]
  }
  draft.value = ''
}

function remove(label: string) {
  labels.value = labels.value.filter((item) => item !== label)
}

function confirm() {
  addDraft()
  emit('confirm', [...labels.value])
  emit('update:modelValue', false)
}
</script>
